import { useMemo, useState } from "react";
import type { LinkableItemOption } from "web_myplann/Portfolio/Types/linkableItemOption";

export const useLinkableItemSearch = (options: LinkableItemOption[]) => {
	const [search, setSearch] = useState("");

	const filteredOptions = useMemo(() => {
		const query = search.trim().toLocaleLowerCase("cs");
		if (!query) {
			return options;
		}
		return options.filter((option) =>
			`${option.title} ${option.subtitle}`
				.toLocaleLowerCase("cs")
				.includes(query),
		);
	}, [options, search]);

	return { search, setSearch, filteredOptions };
};
